export default "__VITE_PUBLIC_ASSET__2b945693__"